<template>
  <div>
    <div class="field-box" @click="showPicker">
      <div>{{displayValue}}</div>
      <van-icon name="calendar-o" size="18" />
    </div>
    <van-popup v-model="isShowPicker" position="bottom" :style="{height:'40%'}" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'QDatePicker',
  props: {
    value: [String, Number, Object]
  },
  watch: {
    value: {
      handler(val) {
        this.init(val);
      },
      immediate: true
    }
  },
  data() {
    return {
      isShowPicker: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 31),
      currentDate: null,
      displayValue: ''
    }
  },
  methods: {
    showPicker() {
      this.isShowPicker = true;
    },
    onCancel() {
      this.isShowPicker = false;
    },
    onConfirm(value) {
      const formatVal = value ? moment(value).format('YYYY-MM-DD') : value;
      this.$emit('input', formatVal);
      this.$emit('change', formatVal);
      this.displayValue = formatVal;
      this.isShowPicker = false;
    },
    init(dateStr) {
      this.displayValue = dateStr;
      this.currentDate = dateStr ? moment(dateStr).toDate() : moment().toDate();
    }
  }
}
</script>

<style lang="stylus" scoped>
.field-box
  box-sizing border-box
  height 30px
  display flex
  justify-content space-between
  align-items center
  padding 5px 10px
  border 1px solid #ccc
  border-radius 6px
  font-size 14px
  color #333333
  background-color #eee
  div
    flex 1
    width 100px
</style>